var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.showHeader)?_c('header',{staticClass:"header"},[_vm._m(0)]):_vm._e(),_c('main',{staticClass:"content"},[_c('router-view')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nes-container is-centered"},[_c('h2',[_vm._v("VAA Community Track Manager")])])
}]

export { render, staticRenderFns }